import React from "react";
import MessageBlocks from "components/commsLog/MessageBlocks";
import { editorRows } from "utils/commsBlocks";

// Mirrors ApprovalBlockEditor in the app: the words are inputs, the rest renders as sent.
const MessageEditor = ({ blocks, text, values, onChangeText, onChangeValues }) => {
  const editsBlocks = values.length > 0;
  const wordlessBlocks = blocks?.length > 0 && !editsBlocks;

  return (
    <div className="space-y-3">
      {editsBlocks ? (
        <div className="space-y-3">
          <p className="text-xs text-darkgray">
            Edit what the vendors read. Images and buttons are part of the message and
            are not editable here.
          </p>
          {editorRows(blocks).map((row, position) =>
            row.kind === "fixed" ? (
              <MessageBlocks key={`fixed-${position}`} blocks={row.blocks} />
            ) : (
              <textarea
                key={`field-${row.index}`}
                className="min-h-[160px] w-full rounded-md border border-mediumgray p-3 font-sans text-sm"
                value={values[row.index] ?? ""}
                onChange={(event) =>
                  onChangeValues(
                    values.map((value, at) =>
                      at === row.index ? event.target.value : value,
                    ),
                  )
                }
              />
            ),
          )}
        </div>
      ) : (
        <label className="flex flex-col gap-1">
          <span className="text-xs text-darkgray">Edit before sending</span>
          <textarea
            className="min-h-[260px] w-full rounded-md border border-mediumgray p-3 font-sans text-sm"
            value={text}
            onChange={(event) => onChangeText(event.target.value)}
          />
        </label>
      )}

      {wordlessBlocks ? (
        <div className="space-y-2">
          <div className="rounded-md bg-orange-50 p-3 text-sm text-orange-800">
            <p className="text-xs uppercase tracking-wide">
              This one carries no editable words
            </p>
            <p>
              The vendors only see what is below. The text above feeds the comms log,
              not what they read.
            </p>
          </div>
          <MessageBlocks blocks={blocks} />
        </div>
      ) : null}
    </div>
  );
};

export default MessageEditor;
